type PerformaceStorageData = {
  storage: string;
  outbound: string;
  objectCluster: string;
  price: string;
};

export const PERFORMANCE_STORAGE_DATA: PerformaceStorageData[] = [
  {
    storage: "250 GB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$5",
  },
  {
    storage: "500 GB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$10",
  },
  {
    storage: "1 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$20",
  },
  {
    storage: "5 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$100",
  },
  {
    storage: "10 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$200",
  },
  {
    storage: "20 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$400",
  },
  {
    storage: "30 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$600",
  },
  {
    storage: "40 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$800",
  },
  {
    storage: "50 TB",
    outbound: "Unlimited",
    objectCluster: "Unlimited",
    price: "$1000",
  },
];
